import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { invalidFormValue, isValidEmail, isValidPhoneNumber } from '@components/utils';


export const selectPartnersRegistrationState = (state: RootState) => state.partnersRegistration;
export const selectShowInvalids = (state: RootState) => state.partnersRegistration.showInvalids;

export const selectContactPerson = (state: RootState) => state.partnersRegistration.contactPerson;
export const selectClientName = (state: RootState) => state.partnersRegistration.clientName;
export const selectEmail = (state: RootState) => state.partnersRegistration.email;
export const selectPhoneNumber = (state: RootState) => state.partnersRegistration.phoneNumber;

export const selectStreet = (state: RootState) => state.partnersRegistration.street;
export const selectCity = (state: RootState) => state.partnersRegistration.city;
export const selectPostalCode = (state: RootState) => state.partnersRegistration.postalCode;
export const selectInvoiceStreet = (state: RootState) => state.partnersRegistration.invoiceStreet;
export const selectInvoiceCity = (state: RootState) => state.partnersRegistration.invoiceCity;
export const selectInvoicePostalCode = (state: RootState) => state.partnersRegistration.invoicePostalCode;

export const selectRegistrationNumber = (state: RootState) => state.partnersRegistration.registrationNumber;
export const selectVatnumber = (state: RootState) => state.partnersRegistration.vatnumber;
export const selectSalesMan = (state: RootState) => state.partnersRegistration.salesMan;
export const selectMessage = (state: RootState) => state.partnersRegistration.message;



export const selectIsValid = createSelector(
	[
		selectContactPerson,
		selectClientName,
		selectEmail,
		selectPhoneNumber,
		selectStreet,
		selectCity,
		selectPostalCode,
		selectInvoiceStreet,
		selectInvoiceCity,
		selectInvoicePostalCode,
		selectRegistrationNumber,
		selectVatnumber,
	],(
		contactPerson: string | null,
		clientName: string | null,
		email: string | null,
		phoneNumber: string | null,
		street: string | null,
		city: string | null,
		postalCode: string | null,
		invoiceStreet: string | null,
		invoiceCity: string | null,
		invoicePostalCode: string | null,
		registrationNumber: string | null,
		vatnumber: string | null,
	) => {
		if (invalidFormValue(contactPerson)) return false;
		if (invalidFormValue(clientName)) return false;
		if (invalidFormValue(email) || !isValidEmail(email)) return false;
		if (invalidFormValue(phoneNumber) || !isValidPhoneNumber(phoneNumber)) return false;
		if (invalidFormValue(invoiceStreet)) return false;
		if (invalidFormValue(invoiceCity)) return false;
		if (invalidFormValue(invoicePostalCode)) return false;
		if (process.env.SHOW_COMPANY_REGISTRATION_ID === 'TRUE' && invalidFormValue(registrationNumber)) return false;
		if (invalidFormValue(vatnumber)) return false;
		if (street || city || postalCode) {
			if (invalidFormValue(street)) return false;
			if (invalidFormValue(city)) return false;
			if (invalidFormValue(postalCode)) return false;
		}
		return true;
});